import React, { useRef, useEffect } from 'react';
import './DataExtractionAnimation.css';

const DataExtractionAnimation = () => {
  const containerRef = useRef(null);

  // Trigger animation on component mount
  useEffect(() => {
    const timer = setTimeout(() => {
      triggerAnimation();
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  // Function to trigger/replay animation
  const triggerAnimation = () => {
    if (containerRef.current) {
      const svg = containerRef.current.querySelector('svg');
      if (svg) {
        // Reset animation by removing and re-adding the animated class
        svg.classList.remove('animated');
        void svg.offsetWidth; // Force reflow
        svg.classList.add('animated');
      }
    }
  };

  const handleMouseEnter = () => {
    triggerAnimation();
  };

  return (
    <div
      ref={containerRef}
      className="data-extraction-container"
      onMouseEnter={handleMouseEnter}
      role="img"
      aria-label="Data extraction animation - hover to replay"
    >
      <svg
        className="animated"
        id="freepik_stories-data-extraction"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsSvgjs="http://svgjs.com/svgjs"
      >
        <style>{`
          svg#freepik_stories-data-extraction:not(.animated) .animable {opacity: 0;}
          svg#freepik_stories-data-extraction.animated #freepik--Shadow--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}
          svg#freepik_stories-data-extraction.animated #freepik--Extraction--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}
          svg#freepik_stories-data-extraction.animated #freepik--Folders--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn,1.5s Infinite  linear wind;animation-delay: 0s,1s;}
          svg#freepik_stories-data-extraction.animated #freepik--Documents--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft,1.5s Infinite  linear wind;animation-delay: 0s,1s;}
          svg#freepik_stories-data-extraction.animated #freepik--Device--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}
          svg#freepik_stories-data-extraction.animated #freepik--Desk--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}
          svg#freepik_stories-data-extraction.animated #freepik--Character--inject-26 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}

          @keyframes slideLeft {
            0% {
              opacity: 0;
              transform: translateX(-30px);
            }
            100% {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }

          @keyframes wind {
            0% {
              transform: rotate(0deg);
            }
            25% {
              transform: rotate(1deg);
            }
            75% {
              transform: rotate(-1deg);
            }
          }
        `}</style>

        <g
          id="freepik--Shadow--inject-26"
          className="animable"
          style={{ transformOrigin: '245.18px 412.39px' }}
        >
          <ellipse
            id="freepik--path--inject-26"
            cx="245.18"
            cy="412.39"
            rx="193.89"
            ry="11.32"
            style={{
              fill: 'rgb(245, 245, 245)',
              transformOrigin: '245.18px 412.39px',
            }}
            className="animable"
          />
        </g>

        <g
          id="freepik--Extraction--inject-26"
          className="animable"
          style={{ transformOrigin: '252.305px 198.235px' }}
        >
          <path
            d="M396.51,241.47c-7.08,0-15.44-12.93-22.82-24.35-4.84-7.48-9.54-14.75-14.54-20H375.7v-8H355.4c3.63-4.14,7.07-9.45,10.6-14.9,5.54-8.58,12.44-19.25,17.71-19.25h15.52v-8H383.71c-9.63,0-16.82,11.13-24.43,22.91-5.54,8.57-12.44,19.24-17.72,19.24H164.42c-5.27,0-12.17-10.67-17.71-19.24C139.09,158.1,131.9,147,122.28,147H106.75v8h15.53c5.27,0,12.17,10.67,17.71,19.25,3.52,5.45,7,10.76,10.59,14.9H78.68v8h80.66c-5,5.25-9.71,12.52-14.54,20-7.38,11.41-15.74,24.35-22.82,24.35H92.56v8H122c11.43,0,20.23-13.6,29.53-28,7.38-11.42,15.74-24.35,22.82-24.35H344.15c7.08,0,15.44,12.93,22.82,24.35,9.31,14.4,18.1,28,29.54,28h29.42v-8Z"
            style={{
              fill: 'rgb(38, 50, 56)',
              transformOrigin: '252.305px 198.235px',
            }}
            id="el3n1v8ycjfoh"
            className="animable"
          />
        </g>

        <g
          id="freepik--Folders--inject-26"
          className="animable"
          style={{ transformOrigin: '94.685px 191.18px' }}
        >
          <path
            d="M122.32,226.15H115a5.16,5.16,0,0,0-4.29,2.3l-1.07,1.62a4.71,4.71,0,0,1-3.93,2.11H86.78a3.07,3.07,0,0,0-3.07,3.08v29.53h42.65V232.18l-.38-2.83A3.69,3.69,0,0,0,122.32,226.15Z"
            style={{
              fill: 'rgb(64, 123, 255)',
              transformOrigin: '105.035px 245.47px',
            }}
            id="elpcu4kgs0bgs"
            className="animable"
          />
          <rect
            x="86.91"
            y="235.92"
            width="36.25"
            height="24.79"
            style={{
              fill: 'rgb(38, 50, 56)',
              transformOrigin: '105.035px 248.315px',
            }}
            id="el7dst49zvxe6"
            className="animable"
          />
          <path
            d="M75.2,117.57h7.91a5.56,5.56,0,0,1,4.63,2.48l1.15,1.75a5.12,5.12,0,0,0,4.25,2.28h20.41a3.31,3.31,0,0,1,3.31,3.31v29.16a2.71,2.71,0,0,1-2.71,2.71H73.56a2.71,2.71,0,0,1-2.71-2.71V124.08l.41-3.06A4,4,0,0,1,75.2,117.57Z"
            style={{
              fill: 'rgb(64, 123, 255)',
              transformOrigin: '93.855px 138.415px',
            }}
            id="el4d8ox7huv3k"
            className="animable"
          />
        </g>

        <g
          id="freepik--Documents--inject-26"
          className="animable"
          style={{ transformOrigin: '401.99px 197.425px' }}
        >
          <rect
            x="388.48"
            y="213.89"
            width="45.46"
            height="61.18"
            style={{
              fill: 'rgb(64, 123, 255)',
              transformOrigin: '411.21px 244.48px',
            }}
            id="el7uh3zmr6hfk"
            className="animable"
          />
          <rect
            x="390.28"
            y="119.78"
            width="41.33"
            height="55.62"
            style={{
              fill: 'rgb(64, 123, 255)',
              transformOrigin: '410.945px 147.59px',
            }}
            id="elypj10vire1j"
            className="animable"
          />
          <rect
            x="370.04"
            y="165.99"
            width="41.33"
            height="55.62"
            style={{
              fill: 'rgb(64, 123, 255)',
              transformOrigin: '390.705px 193.8px',
            }}
            id="el7ik3j0h14u6"
            className="animable"
          />
        </g>

        <g
          id="freepik--Device--inject-26"
          className="animable animator-active"
          style={{ transformOrigin: '254.177px 219.695px' }}
        >
          <path
            d="M333.51,155.89h-12.1L312,263h12.1a5.11,5.11,0,0,0,5-4.59l8.56-97.9A4.13,4.13,0,0,0,333.51,155.89Z"
            style={{
              fill: 'rgb(38, 50, 56)',
              transformOrigin: '324.845px 209.445px',
            }}
            id="elucpu9nncg48"
            className="animable"
          />
          <path
            d="M321.35,263H174.87a4.13,4.13,0,0,1-4.18-4.59l8.56-97.9a5.11,5.11,0,0,1,5-4.58H330.72a4.13,4.13,0,0,1,4.18,4.58l-8.56,97.9A5.11,5.11,0,0,1,321.35,263Z"
            style={{
              fill: 'rgb(38, 50, 56)',
              transformOrigin: '252.794px 209.465px',
            }}
            id="elxzkq3qdddy"
            className="animable"
          />
        </g>

        <g
          id="freepik--Desk--inject-26"
          className="animable"
          style={{ transformOrigin: '252.32px 344.5px' }}
        >
          <rect
            x="156.76"
            y="290.33"
            width="205.63"
            height="114.97"
            style={{
              fill: 'rgb(64, 123, 255)',
              transformOrigin: '259.575px 347.815px',
            }}
            id="elispte0dypef"
            className="animable"
          />
          <rect
            x="137.55"
            y="290.33"
            width="210.56"
            height="10.17"
            style={{
              fill: 'rgb(64, 123, 255)',
              transformOrigin: '242.83px 295.415px',
            }}
            id="elr0e8cwpzid"
            className="animable"
          />
          <rect
            x="253.32"
            y="305.99"
            width="86.87"
            height="99.31"
            style={{
              fill: 'rgb(64, 123, 255)',
              transformOrigin: '296.755px 355.645px',
            }}
            id="el32hgwo8pqq4"
            className="animable"
          />
        </g>

        <g
          id="freepik--Character--inject-26"
          className="animable"
          style={{ transformOrigin: '226.028px 283.219px' }}
        >
          <path
            d="M209.34,183.11c-1.43,2,1.72,8.45,1.72,8.45l-14.19,1.71,2.78-15.47S211,180.73,209.34,183.11Z"
            style={{
              fill: 'rgb(206, 122, 99)',
              transformOrigin: '203.965px 185.535px',
            }}
            id="elsl71nazia"
            className="animable"
          />
          <path
            d="M184.86,200.07a2.93,2.93,0,0,0-5,.58c-3.15,6.74-11.1,24.61-11.13,33.29,0,10.81,31.75,17.21,31.75,17.21l1.92-6.21L180.56,231.5l6.29-14.83S188.41,204.94,184.86,200.07Z"
            style={{
              fill: 'rgb(64, 123, 255)',
              transformOrigin: '185.565px 225.035px',
            }}
            id="el1651xw75he8"
            className="animable"
          />
          <path
            d="M233.78,254.77s-15.65,5.12-41.28,1L180.21,204a9,9,0,0,1,4.52-9.82c5.27-2.92,15.71-5.66,36.3-4.53a11.49,11.49,0,0,1,10.54,8.83Z"
            style={{
              fill: 'rgb(64, 123, 255)',
              transformOrigin: '206.893px 223.382px',
            }}
            id="eliu3d9gxpzer"
            className="animable"
          />
          <path
            d="M192.84,254.53s-2.2,6.4-2.52,22c-.2,9.3-1.11,24-1.81,34.39-.2,3-.39,5.68-.54,7.71a24.11,24.11,0,0,1-1.78,7.5c-.68,1.66-1.53,3.94-2.41,6.77A106.1,106.1,0,0,0,180,350.5c-2.33,17.44-5,51.24-5,51.24l8.63,1.12,21.26-78.77,22.65-69.62Z"
            style={{
              fill: 'rgb(38, 50, 56)',
              transformOrigin: '201.27px 328.665px',
            }}
            id="elfr2qbyr77cc"
            className="animable"
          />
          <path
            d="M235.47,202.29c3.76,6.9,5.21,11,6.5,12.69a.77.77,0,0,0,.73.31l21.95-3.19a.78.78,0,0,1,.86.53l1.77,5.43a.78.78,0,0,1-.5,1l-20.58,7a10.7,10.7,0,0,1-10.95-1.92,58.25,58.25,0,0,1-14-18.38c-1.58-3.12-5.25-8.9.78-14C227,187.53,233,197.71,235.47,202.29Z"
            style={{
              fill: 'rgb(64, 123, 255)',
              transformOrigin: '243.008px 208.774px',
            }}
            id="el9c5n71mvkb"
            className="animable"
          />
          <path
            d="M210,167.28a6.17,6.17,0,0,1,2.64,3.95c.4,2.12-1.6,3-3.55,2.24-1.76-.68-4.08-2.61-3.59-4.67A2.85,2.85,0,0,1,210,167.28Z"
            style={{
              fill: 'rgb(206, 122, 99)',
              transformOrigin: '209.062px 170.211px',
            }}
            id="el24anhr8b2wz"
            className="animable"
          />
        </g>

        <defs>
          <filter id="active" height="200%">
            <feMorphology
              in="SourceAlpha"
              result="DILATED"
              operator="dilate"
              radius="2"
            />
            <feFlood floodColor="#32DFEC" floodOpacity="1" result="PINK" />
            <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
            <feMerge>
              <feMergeNode in="OUTLINE" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default DataExtractionAnimation;
